module.exports = "/images/everestPath7.png?f048cb5cd91c20299d73487ee95a465b";